// extracted by mini-css-extract-plugin
export default {"container":"Menus_container__IqRAN","item":"Menus_item__mMPM-"};